import { useState } from "react";
import FixaTabs, {
  FixaTab,
  FixaTabPanel,
} from "../../../wrappers/FixaTabs/FixaTabs";
import { FilterValue, GroupFilter, InputType } from "../../types/filter";
import { FilterTabSelect } from "./FilterTabSelect";
import { FilterTabMultiSelect } from "./FilterTabMultiSelect";
import FilterTabsCss from "./FilterTabs.module.css";
import {
  removeFilterValueFromValues,
  valueIsInFilterValues,
} from "../../utils/filter/filtervalue";

interface FilterTabsProps {
  filter: GroupFilter;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
}

export const FilterTabs = ({
  filter,
  filterValues,
  setFilterValues,
}: FilterTabsProps) => {
  // Set first enabled filter with value as active
  const enabledFilters = filter.filters.filter(({ enabled }) => enabled);
  const enabledFiltersWithValue = enabledFilters.filter(({ id }) =>
    valueIsInFilterValues(filterValues, id)
  );
  const [activeTab, setActiveTab] = useState(
    enabledFiltersWithValue[0]?.id ??
      enabledFilters[0]?.id ??
      filter.filters[0]!.id
  );
  return (
    <FixaTabs
      className={FilterTabsCss["filter-tabs"] ?? ""}
      onTabChanged={(tab) => {
        // Remove values for all filters in group
        setActiveTab(tab);
        let updatedFilterValues = filterValues;
        for (const { id } of filter.filters.filter(({ enabled }) => enabled)) {
          updatedFilterValues = removeFilterValueFromValues(
            updatedFilterValues,
            id
          );
        }
        setFilterValues(updatedFilterValues);
      }}
      tabs={filter.filters
        .filter(({ enabled }) => enabled)
        .map(({ id, title }) => (
          <FixaTab
            className={FilterTabsCss["filter-tab"] ?? ""}
            key={id}
            text={title}
            tabPanelId={id}
            data-testid={`pill-group-tab-${id}`}
          />
        ))}
      tabPanels={filter.filters
        .filter(({ enabled }) => enabled)
        .map((enabledFilter) => {
          const { inputType, id } = enabledFilter;
          switch (inputType) {
            case InputType.Select: {
              return (
                <FixaTabPanel key={id} tabPanelId={id}>
                  <FilterTabSelect
                    filter={enabledFilter}
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                  />
                </FixaTabPanel>
              );
            }
            case InputType.MultiSelect: {
              return (
                <FixaTabPanel key={id} tabPanelId={id}>
                  <FilterTabMultiSelect
                    filter={enabledFilter}
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                  />
                </FixaTabPanel>
              );
            }
            default:
              return <FixaTabPanel key={id} tabPanelId={id} />;
          }
        })}
      activeTab={activeTab}
    />
  );
};
